import { ApiResponse } from '@ace/core';

import { EndpointCallParams } from '@core/api/endpointCallParams';
import { IApiStore } from '@core/api/apiStore';

export type DeleteLogoParams = {
    id: string;
    delete: boolean;
};

export const performDeleteLogo = async (
    api: IApiStore,
    params: EndpointCallParams<DeleteLogoParams>,
): Promise<ApiResponse> => {
    const { payload, ...rest } = params;
    const { id, ...restOfPayload } = payload;
    const req = api
        .post(
            `identity-app/api/v1/Companies/CompanyLogo/${id}` ,{
                payload,
                ...rest,
            },
            {delete: restOfPayload.delete}
        );

    return req;
}
